import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './CronometroModal.css';
import { Toaster, toast } from 'react-hot-toast';
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement('#root');

const CronometroModal = ({ isOpen, onRequestClose, activity }) => {
  const [startTime, setStartTime] = useState(null);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [totalWorkedHours, setTotalWorkedHours] = useState(activity.horas_get || 0);
  const token = localStorage.getItem("access_token");
  const navigate = useNavigate();

  // Inicializar el cronómetro cuando el modal se abre
  useEffect(() => {
    if (isOpen) {
      setStartTime(new Date());

      if (activity.horas_estandar) {
        const [hours, minutes, seconds] = activity.horas_estandar.split(':').map(Number);
        setElapsedSeconds(hours * 3600 + minutes * 60 + seconds);
      } else {
        setElapsedSeconds(0);
      }
    }
  }, [isOpen, activity.horas_estandar]);

  // Actualizar el tiempo transcurrido basado en la diferencia de tiempo real
  useEffect(() => {
    if (startTime) {
      const intervalId = setInterval(() => {
        const now = new Date();
        const secondsSinceStart = Math.floor((now - startTime) / 1000) + (activity.horas_estandar ? elapsedSeconds : 0);
        setElapsedSeconds(secondsSinceStart);

        // Guardar automáticamente cada 10 segundos
        if (secondsSinceStart % 10 === 0) {
          const intervals = Math.floor(secondsSinceStart / 900); // 900 segundos = 15 minutos
          const newWorkedHours = intervals * 0.25;

          axios
            .put(
              `${process.env.REACT_APP_BACKEND_URL}/update_activity_status`,
              {
                id: activity.id,
                horas_get: parseFloat(newWorkedHours.toFixed(2)),
                horas_estandar: formatElapsedTime(secondsSinceStart),
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
            .then((response) => {
              console.log('Auto-saved successfully:', response.data);
            })
            .catch((error) => {
              console.error('Error auto-saving:', error);
            });

          setTotalWorkedHours(newWorkedHours);
        }
      }, 1000); // Actualiza cada segundo

      return () => clearInterval(intervalId);
    }
  }, [startTime, activity.id, activity.horas_estandar, token]);

  // Detener el cronómetro y guardar
  const handleStop = () => {
    const toastId = toast.loading('Actualizando actividad...');

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/update_activity_status`,
        {
          id: activity.id,
          horas_get: parseFloat(totalWorkedHours.toFixed(2)),
          horas_estandar: formatElapsedTime(elapsedSeconds),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log('Activity updated:', response.data);
        toast.dismiss(toastId);
        toast.success('Actividad Cronometrada');
        setTimeout(() => {
          onRequestClose();
          navigate('/MisAsignaciones');
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        console.error('Error updating activity:', error);
        toast.dismiss(toastId);
        toast.error('Error al finalizar actividad: ' + error.message);
      });
  };

  // Formatear el tiempo transcurrido
  const formatElapsedTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <>
      <SessionManager />
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h1 className="modal-title">Cronómetro</h1>
        {activity && (
          <div>
            <p><strong>Código de Proyecto:</strong> {activity.codigo_proyecto}</p>
            <p><strong>Razón Social:</strong> {activity.razon_social}</p>
            <p><strong>Filial:</strong> {activity.filial}</p>
            <p><strong>Nombre Actividad GET:</strong> {activity.nombre_actividad_get}</p>
            <p><strong>Tiempo Transcurrido (HH:MM:SS):</strong> {formatElapsedTime(elapsedSeconds)}</p>
            <p><strong>Horas Trabajadas:</strong> {totalWorkedHours.toFixed(2)} horas</p>
            <button className="stop-button" onClick={handleStop}>
              Guardar tiempo y salir
            </button>
          </div>
        )}
        <Toaster />
      </Modal>
    </>
  );
};

export default CronometroModal;